import { fromEvent as b, Subject as m, Subscription as f } from "rxjs";
import { debounceTime as v, startWith as g, map as _, distinctUntilChanged as w, share as O, finalize as y } from "rxjs/operators";
import { css as l } from "lit";
const A = ["button", "cell", "checkbox", "columnheader", "gridcell", "heading", "link", "menuitem", "menuitemcheckbox", "menuitemradio", "option", "radio", "row", "rowgroup", "rowheader", "switch", "tab", "tooltip", "tree", "treeitem"];
class x {
  static getAccessibleName(t, e = 0, s = []) {
    if (!(t instanceof Element) || e > 5 || s.includes(t))
      return "";
    s.push(t);
    let i = "";
    if (t.hasAttribute("aria-labelledby")) {
      const o = t.getAttribute("aria-labelledby");
      o && (i = o.split(/\s+/).map((c) => {
        const u = document.getElementById(c);
        return u ? this.getAccessibleName(u, e + 1, s) : "";
      }).join(" "));
    }
    if (!i.trim() && t.hasAttribute("aria-label")) {
      const o = t.getAttribute("aria-label");
      o && o.trim() && (i = o);
    }
    if (i.trim() || this.hasRole(t, "presentation") || this.hasRole(t, "none") || (i = t.getAttribute("placeholder") || t.getAttribute("alt") || t.getAttribute("title") || ""), !i.trim() && this._isEmbedded(t))
      if (this.hasRole(t, "button") || this.hasRole(t, "textbox"))
        i = t.value || t.textContent;
      else if (this.hasRole(t, "combobox") || this.hasRole(t, "listbox")) {
        const o = this.querySelector(t, ":selected") || this.querySelector(t, "option");
        i = o ? this.getAccessibleName(o, e + 1, s) : t.value || "";
      } else
        this.hasRole(t, "range") && (i = t.getAttribute("aria-valuetext") || t.getAttribute("aria-valuenow") || t.value || "");
    return !i.trim() && (e > 0 || A.includes(this._getRole(t)) || t.closest("label")) && (i = this._getContent(t)), !i.trim() && t instanceof Text && (i = this._getContent(t)), i.trim() || (i = t.title || ""), `${this._getPsuedoContent(t, ":before")}${i}${this._getPsuedoContent(t, ":after")}`;
  }
  static hasRole(t, e) {
    return t instanceof Element && this._getRole(t) === e;
  }
  static querySelectorAll(t, e) {
    const s = [];
    return this.walk(t, (i) => {
      i instanceof Element && this.hasRole(i, e) && s.push(i);
    }), s;
  }
  static querySelector(t, e) {
    return this.querySelectorAll(t, e)[0];
  }
  static walk(t, e) {
    e(t), this._getChildren(t).forEach((s) => {
      this.walk(s, e);
    });
  }
  static _getParent(t) {
    return this._getOwner(t) || t.parentNode;
  }
  static findParent(t, e) {
    const s = this._getParent(t);
    if (s != null)
      return e(s) ? s : this.findParent(s, e);
  }
  static _getRole(t) {
    return t instanceof Element && t.getAttribute("role") || "";
  }
  static _getOwner(t) {
    return t instanceof Element ? t.id == null ? null : document.querySelector(`[aria-owns~="${t.id}"]`) : null;
  }
  static _isHidden(t) {
    if (!(t instanceof Element))
      return !1;
    const e = window.getComputedStyle(t);
    return e.display === "none" || e.visibility === "hidden" || t.getAttribute("aria-hidden") === "true";
  }
  static _getChildren(t) {
    const e = [];
    for (let i = 0; i < t.childNodes.length; i++) {
      const o = t.childNodes[i];
      this._getOwner(o) || this._isHidden(o) || e.push(o);
    }
    if (!(t instanceof Element))
      return e;
    const s = t.getAttribute("aria-owns") || [];
    for (let i = 0; i < s.length; i++) {
      const o = document.getElementById(s[i]);
      o && this._getOwner(o) === t && !this._isHidden(o) && e.push(o);
    }
    return e;
  }
  static _getPsuedoContent(t, e) {
    if (!(t instanceof Element))
      return "";
    const s = window.getComputedStyle(t, e), i = s.getPropertyValue("content"), o = s.display != null && s.display.substr(0, 6) === "inline";
    return i ? i.substr(0, 1) !== '"' ? "" : o ? i.slice(1, -1) : ` ${i.slice(1, -1)} ` : "";
  }
  static _getContent(t) {
    const e = this._getChildren(t);
    let s = "";
    for (let i = 0; i < e.length; i++) {
      const o = e[i];
      o instanceof Text ? s += o.textContent : o instanceof Element && (o.tagName.toLowerCase() === "br" ? s += `
` : window.getComputedStyle(o) != null && window.getComputedStyle(o).display != null && window.getComputedStyle(o).display.substr(0, 6) === "inline" && o.tagName.toLowerCase() !== "input" && o.tagName.toLowerCase() !== "img" ? s += this.getAccessibleName(o, 1) : s += ` ${this.getAccessibleName(o, 1)} `);
    }
    return s;
  }
  static _isEmbedded(t) {
    if (!t.parentElement || !Object.prototype.hasOwnProperty.call(t, "labels"))
      return !1;
    const e = t.parentElement.closest("label");
    return !!e && !Array.prototype.includes.call(t.labels, e);
  }
}
class z {
  static getAccessibleName(t) {
    return x.getAccessibleName(t);
  }
}
function T(n, t) {
  return Object.keys(t).forEach((e) => n.addEventListener(e, t[e])), { destroy: () => {
    Object.keys(t).forEach((e) => n.removeEventListener(e, t[e]));
  } };
}
const r = { sm: 0, md: 768, lg: 1200, xl: 1500 };
r.small = r.sm, r.medium = r.md, r.large = r.lg, r.xlarge = r.xl;
const p = Object.entries(r).map(([n, t]) => {
  const e = typeof (s = t) == "number" ? s : parseInt(s.replace("px", ""), 10);
  var s;
  return r[n] = e, { bp: n, width: e };
}).sort((n, t) => t.width - n.width), C = [...p].reverse(), E = (n) => typeof n == "number" ? window.innerWidth < n : window.innerWidth < ((t) => {
  const e = C.find(({ width: s }) => r[t] < s);
  return e ? e.width : 1 / 0;
})(n), R = (n, t) => {
  let e = n != null && (typeof (s = n) == "number" ? window.innerWidth >= s : window.innerWidth >= r[s]);
  var s;
  return t != null && (e = e && E(t)), e;
};
function k(n, t) {
  const e = /* @__PURE__ */ new Map(), s = n == null && t == null, i = s ? "default" : `${n}-${t}`;
  return e.get(i) == null && e.set(i, b(window, "resize").pipe(v(100), g(null), _(() => s ? p.find(({ width: o }) => o <= window.innerWidth)?.bp : R(n, t)), w(), O(), y(() => e.delete(i)))), e.get(i);
}
class W {
  static checkStrings(t, e) {
    const s = [];
    let i = 0;
    for (i = 0; i < e.length; i++)
      t[i] !== e[i] && s.push(e[i]);
    return s.join("");
  }
}
function h(n, t) {
  let e;
  return !(t = { custom: !1, bubbles: !1, cancelable: !1, detail: null, composed: !1, ...t }).custom && typeof Event == "function" || t.custom && typeof CustomEvent == "function" ? e = t.custom ? new CustomEvent(n, { bubbles: t.bubbles, cancelable: t.cancelable, detail: t.detail, composed: t.composed }) : new Event(n, { bubbles: t.bubbles, cancelable: t.cancelable, composed: t.composed }) : t.custom ? (e = document.createEvent("CustomEvent"), e.initCustomEvent(n, t.bubbles, t.cancelable, t.detail, t.composed)) : (e = document.createEvent("Event"), e.initEvent(n, t.bubbles, t.cancelable)), e;
}
function a(n) {
  return n.hasAttribute("disabled");
}
class D {
  constructor(t) {
    this._listItemAccessor = t, this.optionsChange = new m(), this._options = [], this.updateOptions();
  }
  get firstOption() {
    return this._options.filter((t) => !a(t)).find((t) => !!t);
  }
  get lastOption() {
    return [...this._options].reverse().filter((t) => !a(t)).find((t) => !!t);
  }
  get selectedOption() {
    return this._selectedOption;
  }
  set selectedOption(t) {
    (t === void 0 || this._options.indexOf(t) > -1 && this._selectedOption !== t) && (this._selectedOption = t, this.selectedOptionIndex = t ? this._options.indexOf(t) : void 0);
  }
  get activeOption() {
    return this._activeOption;
  }
  set activeOption(t) {
    (t === void 0 || this._options.indexOf(t) > -1 && this._activeOption !== t) && (this._activeOption = t, this.activeOptionIndex = t ? this._options.indexOf(t) : void 0, this.activeOptionID = t ? t.id : "");
  }
  get numberOfOptions() {
    return this._options.length;
  }
  reset() {
    this._select(void 0), this._activate(void 0);
  }
  selectByIndex(t) {
    const e = this._options[t];
    e == null || a(e) || this._select(e);
  }
  selectByID(t) {
    const e = this._options.find((s) => s != null && s.id === t);
    e == null || a(e) || this._select(e);
  }
  selectFirst() {
    this.selectedOption !== this.firstOption && this._select(this.firstOption);
  }
  selectLast() {
    this.selectedOption !== this.lastOption && this._select(this.lastOption);
  }
  selectNext() {
    this.selectedOptionIndex != null ? this._select(this._findNext(this.selectedOptionIndex)) : this._select(this.firstOption);
  }
  selectPrevious() {
    this.selectedOptionIndex != null ? this._select(this._findPrevious(this.selectedOptionIndex)) : this._select(this.lastOption);
  }
  selectActive() {
    this.activeOption != null && this._select(this.activeOption);
  }
  activateByIndex(t) {
    const e = this._options[t];
    e != null && this._activate(e);
  }
  activateByID(t) {
    const e = this._options.find((s) => s != null && s.id === t);
    e != null && this._activate(e);
  }
  activateFirst() {
    this.activeOption !== this.firstOption && this._activate(this.firstOption);
  }
  activateLast() {
    this.activeOption !== this.lastOption && this._activate(this.lastOption);
  }
  activateNext() {
    this.activeOptionIndex != null ? this._activate(this._findNext(this.activeOptionIndex)) : this._activate(this.firstOption);
  }
  activatePrevious() {
    this.activeOptionIndex != null ? this._activate(this._findPrevious(this.activeOptionIndex)) : this._activate(this.lastOption);
  }
  updateOptions() {
    this._options = (this._listItemAccessor() || []).filter((t) => !!t) || [], this.optionsChange.next(this._options), this.activeOption != null && this._options.find((t) => t === this.activeOption) == null && this._deactivate(this.activeOption);
  }
  _select(t) {
    this.selectedOption != null && this._deselect(this._selectedOption), this.selectedOption = t, t != null && (a(t) || t.dispatchEvent(h("neselect", { custom: !0, detail: !0 })));
  }
  _deselect(t) {
    this.selectedOption === t && (this.selectedOption = void 0), t?.dispatchEvent(h("neselect", { custom: !0, detail: !1 }));
  }
  _activate(t) {
    this.activeOption != null && this._deactivate(this._activeOption), this.activeOption = t, t != null && (a(t) || t.dispatchEvent(h("neactivate", { custom: !0, detail: !0 })));
  }
  _deactivate(t) {
    this.activeOption === t && (this.activeOption = void 0), t?.dispatchEvent(h("neactivate", { custom: !0, detail: !1 }));
  }
  _findNext(t) {
    return this._options.slice(t + 1).filter((e) => !a(e)).find((e) => !!e) || this.lastOption;
  }
  _findPrevious(t) {
    return this._options.slice(0, t).reverse().filter((e) => !a(e)).find((e) => !!e) || this.firstOption;
  }
}
class N {
  announce(t, e = "polite") {
    return this._liveRegion == null && (this._liveRegion = this._createLiveRegion()), this._liveRegion.setAttribute("aria-live", e), new Promise((s) => {
      this.clear(), this._timeout && clearTimeout(this._timeout), this._timeout = setTimeout(() => {
        this._liveRegion.textContent = t, s();
      }, 100);
    });
  }
  clear() {
    this._liveRegion != null && (this._liveRegion.textContent = "");
  }
  _createLiveRegion() {
    const t = document.createElement("div"), e = "nu-live-announcer", s = document.getElementsByClassName(e);
    for (let i = 0; i < s.length; i += 1)
      s[i].parentNode?.removeChild(s[i]);
    return t.classList.add(e), t.style.cssText += `border: 0 !important;
      clip: rect(0 0 0 0) !important;
      -webkit-clip-path: inset(50%) !important;
      clip-path: inset(50%) !important;
      height: .0625rem !important;
      margin: -0.0625rem !important;
      overflow: hidden !important;
      padding: 0 !important;
      position: absolute !important;
      width: .0625rem !important;
      white-space: nowrap !important;`, t.setAttribute("aria-atomic", "true"), t.setAttribute("aria-live", "polite"), document.body.appendChild(t), t;
  }
}
let d;
const H = (d == null && (d = new N()), d);
class M {
  constructor(t, e) {
    this.element = t, this.options = e, this._label = !1, this._role = !1, this._mutationObserver = new MutationObserver(() => {
      this._handleChange();
    }), this._resizeObserver = new ResizeObserver(() => {
      this._handleChange();
    }), this._label = t.getAttribute("aria-label") != null, this._role = t.getAttribute("role") != null;
  }
  init() {
    this.element.style.overflow = "auto", this._resizeObserver.observe(this.element), this._mutationObserver.observe(this.element, { characterData: !0, childList: !0, subtree: !0 });
  }
  destroy() {
    this._resizeObserver.disconnect(), this._mutationObserver.disconnect(), this.element.style.overflow = "", this._teardown();
  }
  _setup() {
    this._label || this.element.setAttribute("aria-label", this.options.label || "Scrollable content area"), this._role || this.element.setAttribute("role", "region"), this.element.setAttribute("tabindex", "0");
  }
  _teardown() {
    this._label || this.element.removeAttribute("aria-label"), this._role || this.element.removeAttribute("role"), this.element.setAttribute("tabindex", "-1");
  }
  _handleChange() {
    this.element.scrollHeight > this.element.offsetHeight ? this._setup() : this._teardown();
  }
}
class $ {
  constructor(t) {
    this.subscriptions = new f(), this._breakpointClass = null, this.host = t, t.addController(this);
  }
  get isSmall() {
    return this._breakpointClass === "sm";
  }
  get isMedium() {
    return this._breakpointClass === "md";
  }
  get isLarge() {
    return this._breakpointClass === "lg";
  }
  get isXLarge() {
    return this._breakpointClass === "xl";
  }
  get isMobile() {
    return this.isSmall || this.isMedium;
  }
  hostConnected() {
    this.subscriptions.add(k().subscribe((t) => {
      t != null && (this.host.requestUpdate(), this._breakpointClass = t);
    }));
  }
  hostDisconnected() {
    this.subscriptions != null && this.subscriptions.unsubscribe();
  }
}
const B = (n) => {
  let t = {};
  if (window.location.search) {
    const i = window.location.search.substring(1).replace(/&/g, '","').replace(/=/g, '":"');
    t = JSON.parse(`{"${i}"}`, (o, c) => o === "" ? c : decodeURIComponent(c));
  }
  const e = Object.assign(t, n), s = Object.keys(e).reduce((i, o) => (i.push(`${o}=${encodeURIComponent(e[o])}`), i), []).join("&");
  return `${window.location.pathname}?${s}`;
};
var S = ((n) => (n.ESCAPE = "Escape", n.SPACE = " ", n.ENTER = "Enter", n.ARROWUP = "ArrowUp", n.ARROWLEFT = "ArrowLeft", n.ARROWDOWN = "ArrowDown", n.ARROWRIGHT = "ArrowRight", n.HOME = "Home", n.END = "End", n.UPARROW = "ArrowUp", n.RIGHTARROW = "ArrowRight", n.DOWNARROW = "ArrowDown", n.LEFTARROW = "ArrowLeft", n.TAB = "", n.DELETE = "Delete", n.BACKSPACE = "Backspace", n.PGUP = "PageUp", n.PGDOWN = "PageDown", n.SHIFT = "Shift", n.CONTROL = "Control", n.ALT = "Alt", n.COMMAND = "Meta", n))(S || {});
const j = () => Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 3) + Math.floor(1e3 * Math.random()), U = l`.nb-btn{--nb-button-idle:var(--nt-color-action-primary-default, #5c9a1b);--nb-button-active:var(--nt-color-action-primary-active, #487815);border-color:transparent;border-radius:.25em;border-style:solid;border-width:2px;display:inline-block;font-size:var(--nt-size-font-lg, 1.1875rem);font-weight:700;line-height:var(--nt-font-line-height-compact, 1.25rem);padding:.75em 1.25em .825em;text-align:left;text-decoration:none;transition-duration:.2s;transition-property:color,background-color,border-color;transition-timing-function:ease-in}.nb-btn>nucleus-icon.is-after{margin-left:.5em}.nb-btn>nucleus-icon{transform:scale(1.4) translateY(10%)}.nb-btn.is-emphasized{--nb-button-idle:var(--nt-color-action-emphasized-default, #612166);--nb-button-active:var(--nt-color-action-emphasized-active, #4c1a51)}button{font-family:inherit}button:not(:disabled){cursor:pointer}.nb-btn--primary{color:#fff;background-color:var(--nb-button-idle,#5c9a1b)}.nb-btn--primary:active,.nb-btn--primary:focus,.nb-btn--primary:hover{background-color:var(--nb-button-active,#4c1a51)}.nb-btn--secondary{color:var(--nb-button-idle,#5c9a1b);background-color:var(--nt-color-background-white,#fff);border-color:currentColor}.nb-btn--secondary:active,.nb-btn--secondary:focus,.nb-btn--secondary:hover{color:var(--nt-color-font-reversed,#fff);background-color:var(--nb-button-active,#4c1a51);border-color:var(--nb-button-active,#4c1a51)}`, F = l`.nu-visually-hidden{border:0!important;clip:rect(0 0 0 0)!important;-webkit-clip-path:inset(50%)!important;clip-path:inset(50%)!important;height:.0625rem!important;margin:-.0625rem!important;overflow:hidden!important;padding:0!important;position:absolute!important;width:.0625rem!important;white-space:nowrap!important}`, q = l`::after,::before,:host>*{box-sizing:border-box;border-width:0;border-style:solid}@media (prefers-reduced-motion){::after,::before,:host *{animation-delay:0s!important;animation-duration:0s!important;animation-iteration-count:1!important;scroll-behavior:auto!important;transition-delay:0s!important;transition-duration:0s!important}}:host{-webkit-text-size-adjust:100%;color:var(--nt-color-font-primary,#3a3b3d);--nb-font-family:FS Humana,Calibri,Helvetica,Arial,SF Pro Text,Roboto,sans-serif;font-family:var(
      --nt-font-family-default,
      var(--nb-font-family, sans-serif)
    );font-size:var(--nt-size-font-base, 1rem);line-height:1.5;margin:0}[data-whatinput=pointer]{--outline-width:0}:visited{color:var(--nt-color-action-link-visited,#00444d)}hr{color:inherit;border-top-width:1px}b,strong{font-weight:bolder}small{font-size:.875em}sub,sup{font-size:.75em;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}a{color:var(--nt-color-action-link-default,#007481);--outline-offset:2px}button{background-color:transparent;color:inherit;font-family:inherit;font-size:1em;line-height:inherit;margin:0;padding:0;text-align:inherit;border:none}button:disabled{pointer-events:none}button:not(:disabled){cursor:pointer}img,video{display:block;height:auto;max-width:100%}svg:not(:root){overflow:visible}figure{margin:0}table{border-collapse:collapse;border-color:currentColor;text-indent:0}tbody,td,tfoot,th,thead,tr{border-color:inherit;border-width:inherit}fieldset{padding:0;margin:0;min-width:0}input,optgroup,select,textarea{font-family:inherit;font-size:1em;line-height:1.15;margin:0}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}summary{display:list-item;cursor:pointer}[hidden]{display:none!important}p{line-height:var(--nt-font-line-height-open, 1.5);margin-bottom:1.5em;margin-top:0}`, G = l`:host(:focus){outline:var(--outline-width,2px) dashed currentColor;outline-offset:var(--outline-offset,-2px)}`, K = l`.nu-reset-list{list-style-type:none;margin-bottom:0;margin-top:0;padding-left:0}`;
export {
  z as A11yChecker,
  S as Key,
  M as NuScrollable,
  $ as ScreenSizeController,
  B as createUrlQuery,
  j as getRandomId,
  k as nuBreakpoint,
  U as nuButtons,
  W as nuDiff,
  h as nuEvent,
  D as nuListManager,
  T as nuListenerFactory,
  H as nuLiveAnnouncer,
  K as nuResetList,
  F as nuVisuallyHidden,
  q as reset,
  G as resetFocus
};
